export const SLICE_NAME = 'vaReporterReports';
